import styles from "@/styles/ContentHeader.module.scss";
import classnames from "classnames";
import IconArrow from "../svgs/icon_arrow.svg";
import VersatileLink from "@/components/VersatileLink";

export default function ContentHeader({ text, link, viewTypeClassName, main }) {
  const classNames = classnames(styles.header, {
    [styles.grid]: viewTypeClassName === "grid",
    [styles.list]: viewTypeClassName === "list",
    [styles.channelList]: viewTypeClassName === "channelList",
    [styles.pickuplist]: viewTypeClassName === "pickuplist",
    [styles.genrePalette]: viewTypeClassName === "genrePalette",
  });
  return (
    <>
      {main && (
        <h1 className={classNames}>
          <Content text={text} link={link} />
        </h1>
      )}
      {!main && (
        <h2 className={classNames}>
          <Content text={text} link={link} />
        </h2>
      )}
    </>
  );
}

function Content({ text, link }) {
  return (
    <>
      {link && (
        <>
          <VersatileLink className={styles.title} href={link.href}>
            {text}
          </VersatileLink>
          <VersatileLink className={styles.more} href={link.href}>
            <div className={styles.caret}>
              もっと見る
              <IconArrow />
            </div>
          </VersatileLink>
        </>
      )}
      {!link && <div className={styles.title}>{text}</div>}
    </>
  );
}
